export default "__VITE_ASSET__DD00IpbW__"